<template lang="pug">
  ods-select(
    v-model="lang"
    :class="cssClass",
    @change='changeLang')
    ods-option(
      v-for="lang in langs"
      :key="lang"
      :value="lang"
      :label="getLabel(lang)")
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'LangSelector',

  props: {
    cssClass: {
      type: String
    },
    mobile: {
      type: Boolean
    }
  },

  data () {
    return {
      lang: ''
    }
  },

  computed: {
    langs () {
      return Object.keys(this.$i18n.messages)
    }
  },

  methods: {
    ...mapGetters(['getActiveLang']),
    ...mapActions(['changeActiveLangState']),

    getLabel (lang) {
      return this.mobile ? this.$i18n.messages[lang].labelMobile : this.$i18n.messages[lang].label
    },

    async changeLang (lang) {
      await this.changeActiveLangState(lang)
    }
  },

  created () {
    this.lang = this.getActiveLang()
    this.changeActiveLangState(this.lang)
  }
}
</script>
